module.exports = __webpack_public_path__ + "assets/img/thumb-Kaplan-Professional-2-Video.752318c3.webp";